import img0 from '../../utils/images/aboutUs.jfif';
import img1 from '../../utils/images/aboutUs1.JPG';
import img2 from '../../utils/images/aboutUs2.jfif';
import React from 'react';
import { Navbar } from '../../components/Navbar/Navbar';
import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import { fetchAnnouncementData } from '../../Actions/Announcement';
import Ticker from 'react-ticker';
import Tickers from '../../components/Tickers/Tickers';
import Footer from '../../components/Footer/Footer';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAnnouncement } from '../../API/api';
import axios from 'axios';
const Announcement = () => {
  const dispatch = useDispatch();

  const [announcementInfo, setAnnouncementInfo] = useState([]);

  const getData = async () => {
    axios
      .get(getAnnouncement)
      .then(response => {
        setAnnouncementInfo(response.data.data);
      })
      .catch(error => {
        console.log(error);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  // console.log(announcementInfo);
  return (
    <div>
      <Navbar />
      {/* <Ticker >
        {({ index }) => (
          <>
            <div style={{ backgroundColor: "#FF7345", marginTop: "70px" }}>
              <Typography sx={{ fontFamily: "Poppins", marginRight: 2, color: "white" }}>
                Sample News <></>
              </Typography>
            </div>
          </>
        )}
      </Ticker> */}
      {/* <Tickers></Tickers> */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          height: '457px',
          paddingTop: '100px',
          background: `rgba(0, 0, 0,0.8) url(${img0})`,

          backgroundSize: 'cover',
          position: 'relative',
          backgroundPosition: 'center',
          zIndex: -1,
          flexDirection: 'column',
          backgroundBlendMode: 'darken',

          // marginTop: "20px",
        }}
      >
        <Typography
          // variant="h2"
          sx={{
            fontFamily: 'Poppins',
            color: '#FFFFFF',
            justifyContent: 'center',
            width: '100%',
            display: 'flex',
            margin: '100px auto',
            fontWeight: 'bold',
            fontSize: '2.9rem',
            // font: '50pt',
          }}
        >
          Announcements
        </Typography>

      </div>

      <Box sx={{ flexGrow: 1, px: [0, 0, 20], paddingTop: 4, backgroundColor: '#fcfcfc' }}>
        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12 }}>
          {announcementInfo.map(data => (
            // console.log(data.date)

            <Grid item xs={12} sm={12} md={4} sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
              <Card sx={{ marginBottom: 2, boxShadow: '0px 3px 45px #00000008', padding: '12px' }}>
                <div>
                  <CardContent sx={{}}>
                    <Typography
                      sx={{
                        color: '#ed7632',
                        fontSize: '17px',
                        fontFamily: 'Poppins',
                        backgroundColor: '#fef7f3',
                        borderRadius: '22px',
                        padding: '7px 14px',
                        marginTop: '20px',
                        height: '41px',
                        width: '150px',
                        textAlign: 'center',
                      }}
                    >
                      {data.date}
                    </Typography>
                    <Typography sx={{ color: '#151515', fontFamily: 'Poppins', marginTop: '18px', fontWeight: 'bold' }}>
                      {data.title}
                    </Typography>
                    <Typography
                      sx={{
                        color: ' #62392B',
                        fontFamily: 'Poppins',
                        fontSize: '17px',
                        marginTop: '10px',
                      }}
                    >
                      {data.description}
                    </Typography>
                  </CardContent>
                </div>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <br></br>
      <Footer></Footer>
    </div>
  );
};

export default Announcement;
